<template>
  <div class="diagram-legend">
    <v-container fluid>
      <v-row class="justify-start">
        <!-- role -->
        <v-col class="col-xs-2 legend-container" v-if="roleDefinition">
          <v-card class="pa-2 legend-item">
            <div class="legend-item-content d-flex">
              <div
                class="legend-item-role-name text-center text-body-2 mr-2"
                :style="{
                  'background-color': definitionColour(roleDefinition),
                  color: definitionTextColour(roleDefinition)
                }"
              >
                <div class="legend-item-role-name-text px-1">{{ roleDefinition.title }}</div>
              </div>

              <pre class="text-body-2">{{ roleDefinition.description }}</pre>
            </div>
          </v-card>
        </v-col>

        <!-- event -->
        <v-col class="col-xs-2 legend-container" v-if="eventDefinition">
          <v-card class="pa-2 legend-item">
            <div class="legend-item-title text-center mb-2">
              <div class="py-1 px-3 rounded-lg text-body-2">{{ eventDefinition.title }}</div>
            </div>

            <div
              class="legend-item-event-shape d-flex align-center justify-center"
              :style="{
                'background-color': definitionColour(eventDefinition),
                color: definitionTextColour(eventDefinition)
              }"
            >
              <pre class="legend-item-event-shape-description">{{ eventDefinition.description }}</pre>
            </div>
          </v-card>
        </v-col>

        <v-col
          class="col-xs-2 legend-container"
          v-for="cardType in types"
          :key="cardType.id"
        >
          <v-card class="pa-2 legend-item">
            <div class="legend-item-title text-center mb-4">
              <div
                class="py-1 px-3 rounded-xl text-body-2"
                :style="{
                  'background-color': `rgb(${cardType.color.red},${cardType.color.green},${cardType.color.blue})`,
                  color: getTextColour(cardType)
                }"
              >{{ cardType.title }}
              </div>
            </div>

            <pre class="text-body-2">{{ cardType.description }}</pre>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import cardTypesApi from '@/api/cardTypesApi'
import { selectForegroundColor, getDarkThemeColor } from '@/utils/color'
import { isDarkTheme } from '@/composables/useAppTheme'
import { mapState } from 'vuex'

export default {
  methods: {
    getTextColour (cardType) {
      return cardTypesApi.getTextColour(cardType)
    },
    definitionColour (definition) {
      const rgb = definition.color.rgb

      return isDarkTheme() ? getDarkThemeColor(rgb) : rgb
    },
    definitionTextColour (definition) {
      const { red, green, blue } = definition.color

      return selectForegroundColor(red, green, blue)
    }
  },

  computed: {
    ...mapState({
      workflow: state => state.workflow.workflow,
      cardTypes: state => state.cardTypes.cardTypes
    }),
    types () {
      if (!Array.isArray(this.cardTypes)) return []

      return this.cardTypes.filter(({ description }) => description)
    },
    roleDefinition () {
      // console.log(this.workflow.roleDefinition)
      return this.workflow.roleDefinition
    },
    eventDefinition () {
      return this.workflow.eventDefinition
    }
  }
}
</script>

<style scoped>
.diagram-legend {
  padding: 5px 4px;
  border-radius: 8px;
  background-color: var(--light-1);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.legend-item {
  min-width: 230px;
  max-width: 230px;
  height: 200px;
  overflow: hidden;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.legend-container {
  min-width: 250px;
  max-width: 250px;
}

.legend-item-content {
  height: 100%;
  align-items: stretch;
}

.legend-item-role-name {
  width: 30px;
  height: 100%;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  background-color: rgb(224, 224, 224);
}

.legend-item-role-name-text {
  font-size: 14px;
  transform: rotate(180deg);
}

.legend-item-title > div {
  display: inline-block;
}

.legend-item-event-shape {
  color: var(--text-dark);
  display: flex;
  height: 140px;
  padding: 10px;
  margin: 0 20px;
  font-weight: 500;
  position: relative;
  word-break: break-word;
  background-color: rgb(255, 210, 149);
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2);

  .legend-item-event-shape-description {
    font-size: 14px;
    text-align: center;
    font-family: Inter, sans-serif;
  }
}

.legend-item-event-shape::before,
.legend-item-event-shape::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 20px;
  height: 1px;
  background-color: var(--text-dark);
}

.legend-item-event-shape::before {
  left: -20px;
}

.legend-item-event-shape::after {
  right: -20px;
}

pre {
  max-height: 100%;
  white-space: pre-wrap;
  word-break: break-word;
  overflow: hidden;
}
</style>
